export interface ArticleItem {
  slug: string;
  title: string;
  subtitle?: string;
  metaTitle: string;
  breadcrumb: string;
  date: string;
  description: string;
  bodyHtml: string;
}

export const ARTICLES: ArticleItem[] = [
  {
    slug: 'mari-to-acquire-atg-entertainment',
    title:
      'MARI to Acquire ATG Entertainment, a Global Leader in Live Theatre',
    subtitle:
      'AGREEMENT MARKS A NEW CHAPTER FOR ATG AND A DEFINING EXPANSION OF MARI’S LIVE-EVENTS PORTFOLIO',
    metaTitle: 'MARI to Acquire ATG Entertainment | MARI Group',
    breadcrumb: 'MARI to Acquire ATG Entertainment',
    date: 'AUG 11, 2026',
    description:
      'MARI agrees to acquire ATG Entertainment, adding 70 venues across the UK, US and Europe to its global live events portfolio',
    bodyHtml: `
      <p>
        BEVERLY HILLS, Calif. / LONDON, August 11, 2026 – MARI, the global events and experiences company founded by Ariel Emanuel, today announced that it has entered into a definitive agreement to acquire ATG Entertainment, a leading international theater company spanning venue operations, production and ticketing, from Providence Equity Partners L.L.C. ("Providence"). The transaction is subject to regulatory approvals and customary closing conditions. Until completion, MARI and ATG will continue to operate as separate companies.
      </p>

      <p>
        ATG operates a portfolio of 70 venues across the United Kingdom, the United States, Germany, and Spain, including seven on Broadway and ten in London’s West End, as well as an extensive network of regional theaters. Its venues host over 16,000 performances and welcome over 18 million theatergoers each year, and it produces and co-produces work for the West End and Broadway. ATG is a trusted home for leading producers and creative partners, and for landmark productions from “The Lion King” and “Wicked” to “Harry Potter and the Cursed Child.”
      </p>

      <p>
        MARI owns and operates a global portfolio of events and experiences across sports, art, entertainment and lifestyle, including Frieze, Barrett-Jackson, the Miami Open, the Mutua Madrid Open, Hyde Park Winter Wonderland and the Hampton Court Palace and Blenheim Palace Festivals.
      </p>

      <p>
        The acquisition reflects MARI’s conviction in the growing power of live experience and the passionate audiences it brings together, adding theater as a defining part of its portfolio.
      </p>

      <p>
        Following completion, MARI intends to act as a long-term custodian of ATG’s theaters, investing in their preservation and modernization alongside an improved audience experience and support for new productions, to the benefit of theatergoers and producers alike. That commitment will extend across the entire portfolio, from the regional theaters to the West End and Broadway. Across ATG's regional network, MARI's ambition is to build on the role these venues play in their communities, creating new opportunities for local artists and broadening access to live theater. ATG will continue under its existing brand and leadership and retain its commitment to creative independence.
      </p>

      <p>
        Ariel Emanuel, Founder and Principal Investor of MARI, said: “I’ve spent my whole career in entertainment, and I started out in theater. I’ve seen the industry reinvent itself many times, but live has only grown more powerful. Nothing connects great talent with audiences more directly. ATG has built one of the world’s great theater businesses around that experience. This is a long-term bet on where live goes next.”
      </p>

      <p>
        Mark Shapiro, Principal Investor and Board Member of MARI, said: “ATG has exceptional venues, a best-in-class leadership team and a proven record of bringing ambitious work to the stage. Investing in the preservation and modernization of the ATG theaters, and in the audience experience, is job one. MARI’s creative energy will be a strong complement.”
      </p>

      <p>
        Melanie Smith, Global Chief Executive Officer, ATG Entertainment, said: “MARI understands live entertainment and what matters most to ATG: our theaters, the people behind them and the relationships we have built with producers, artists and audiences. That makes MARI the right home for our next chapter. We look forward to this new era and thank Providence for their unwavering support over the past thirteen years.”
      </p>

      <p>
        Sonia Friedman, Founder and Director, Sonia Friedman Productions, a producing partner of ATG Entertainment, said: “As a producer, I have always believed in the power of live theatre to bring people together, challenge perspectives and create unforgettable shared experiences. Our industry has always needed partners prepared to think long term, invest with confidence and support creativity with real ambition. What I find compelling about MARI is its breadth of experience across live events and its respect for creative independence. That combination gives us the chance to champion bold new work, reach broader and more diverse audiences and strengthen the future of live theatre for generations to come.”
      </p>

      <p>
        Andrew Tisdale, Vice Chairman at Providence, added: “We’ve been proud to partner with ATG over the past thirteen years as it has grown into one of the world’s leading live entertainment companies. Together, we’ve supported its international expansion, invested in iconic venues and strengthened the business through strategic acquisitions. Central to that success has been ATG’s fantastic team, which has consistently expanded during our ownership and has been instrumental in driving the company’s growth. We believe ATG is well positioned for its next chapter and that MARI is the right partner to build on that success. We wish the entire ATG team all the best.”
      </p>

      <p>
        Financial terms of the transaction were not disclosed.
      </p>

      <p>
        The Raine Group and Moelis & Company acted as financial advisors, Akin Gump Strauss Hauer & Feld LLP acted as legal advisor, and EY acted as tax advisor to MARI. LionTree served as lead financial advisor and Kirkland & Ellis LLP served as legal counsel to ATG and Providence. Goldman Sachs, Jefferies and Barron International Group also served as financial advisors to ATG and Providence.
      </p>

      <h2>EDITORS’ NOTES</h2>

      <h3>About ATG Entertainment</h3>
      <p>
        ATG Entertainment is a world leader in live entertainment. Our portfolio of venues includes historic theatres, modern live music arenas, studio theatres, cinemas and conference spaces. ATG Entertainment own, operate or programme 70 of the world’s most iconic venues across the UK, the US and Continental Europe, each year entertaining over 18 million audience members. Through our in-house Production companies and working closely with third-party top producers and promoters ATG presents over 16,000 live performances every year. Tickets to those events are sold by the ATG-operated ticketing platform, <a href="https://www.atgtickets.com/" target="_blank" rel="noopener noreferrer">ATGtickets.com</a>.
      </p>

      <h3>About MARI</h3>
      <p>
        MARI is a global events and experiences company with a portfolio of world-class live properties spanning sports, art, lifestyle, and entertainment. These include major international tennis tournaments, among them the Mutua Madrid Open and Miami Open presented by Itaú, Frieze, a leading voice in contemporary art, Hyde Park Winter Wonderland, TodayTix Group, and Barrett-Jackson, the foremost U.S. collector car auction company. MARI delivers live experiences that bring people together, inspire audiences, and shape culture worldwide.
      </p>

      <h3>About Providence Equity Partners L.L.C.</h3>
      <p>
        Providence Equity Partners L.L.C. is a leading middle-market private equity firm with deep sector expertise in media, communications and education focused on North America and Europe. Providence looks to invest in businesses that are benefiting from the long-term growth trends around experiences, learning, and connectivity by partnering with exceptional management teams to build enduring, scaled companies. Founded in 1989 in Providence, Rhode Island, the firm has invested over $40 billion across more than 180 portfolio companies with a transatlantic investment team based primarily in London, New York and Boston. Through disciplined portfolio construction, prudent risk management and a collaborative culture, the firm seeks to deliver strong results across market cycles. To learn more, please visit <a href="https://www.provequity.com/" target="_blank" rel="noopener noreferrer">www.provequity.com</a>.
      </p>
    `,
  },
  {
    slug: 'mari-acquires-collect-a-con',
    title:
      'MARI Acquires Collect-A-Con® The Largest Trading Card, Anime, And Pop Culture Event In The United States',
    metaTitle: 'MARI Acquires Collect-A-Con® | MARI Group',
    breadcrumb: 'MARI Acquires Collect-A-Con®',
    date: 'APR 30, 2026',
    description:
      'MARI acquires Collect-A-Con, the largest US touring pop culture event for trading cards, anime and gaming fans, expanding its global events portfolio',
    bodyHtml: `
      <p>
        BEVERLY HILLS, Calif., Apr. 30, 2026 – MARI, the global events and experiences company, has acquired Collect-A-Con, a rapidly growing multi-city event serving fan communities across trading cards, anime, gaming, and pop culture.
      </p>

      <p>
        Founded in 2021, Collect-A-Con has scaled rapidly, growing from three shows in its first year to 24 planned for 2026, making it the largest touring event of its kind in the United States, with shows taking place in major cities, including Dallas, Orlando, New Jersey, Los Angeles, Atlanta, and Chicago.  
      </p>

      <p>
        The shows draw an average of 25,000 attendees, with more than 500,000 participants annually. Each event brings together trading cards, anime, and pop culture in a single marketplace, combining celebrity guests, anime voice actors, live performances, and extensive merchandise. With over 1,000 vendors, alongside guest appearances, concerts featuring major performing artists, and exclusive drops, each show creates a high-energy experience over a single weekend, bringing fans, creators, and vendors together in one place.
      </p>

      <p>
        The result is sustained activity across each event, with buying, selling, and trading driving repeat participation from both attendees and vendors. MARI will focus on enhancing the overall experience while preserving the community-driven model and culture that have defined Collect-A-Con’s growth. The acquisition also brings a younger, highly active audience into the MARI portfolio, with visitors predominantly ages 18 to 34 – a demographic shaping the future of live entertainment.
      </p>

      <p>
        “Collect-A-Con has built something that is genuinely hard to replicate – a highly engaged community and a format that keeps people coming back,” said Ben Enowitz, Chief Financial Officer at MARI. “We see a significant opportunity to build on that foundation, supporting the collectibles market and bringing the format to more cities and audiences around the world.”
      </p>

      <p>
        Collect-A-Con will continue to operate under its existing brand and leadership team, with MARI and its worldwide infrastructure supporting continued growth and operational development.
      </p>

      <p>
        “Vendors love the opportunity to build direct relationships with customers, while fans are drawn to the sense of community and the in-person ‘treasure hunt’ experience,” said Matthew Weatherly, Co-Founder of Collect-A-Con. “Attendees often spend hours at each event – it’s a good indication of how engaged the audience is. As we grow, people can expect the same experience – from the marketplace and community atmosphere to live moments across the weekend, including trading cards like Pokémon alongside performances from major music artists such as Steve Aoki, Soulja Boy and Waka Flocka Flame.”
      </p>

      <p>
        Financial terms of the transaction were not disclosed.
      </p>

      <h2>EDITORS’ NOTES</h2>

      <h3>About Collect-A-Con</h3>
      <p>
        Collect-A-Con is the largest touring trading card, anime, and pop culture event in the United States. Founded in 2021, the business has grown rapidly into a multi-city series of shows bringing together collectors, vendors, creators, and fans in a large-scale marketplace environment. Each event combines buying, selling, and trading with celebrity guests, live performances, and fan programming, creating a high-energy, community-driven experience. With shows held in major cities across the U.S., Collect-ACon attracts over 500,000 attendees annually and continues to expand its reach to new audiences.
      </p>
      <h3>About MARI</h3>
      <p>
        MARI is a global events and experiences company with a portfolio of world-class live properties spanning sport, art, lifestyle, and entertainment. These include major international tennis tournaments, among them the Mutua Madrid Open and Miami Open presented by Itaú, Frieze, a leading voice in contemporary art, Hyde Park Winter Wonderland, TodayTix Group, a leading digital ticketing and technology company for theatre and live performance, and Barrett-Jackson, the foremost U.S. collector car auction company. MARI delivers live experiences that bring people together, inspire audiences, and shape culture worldwide.  
      </p>
    `,
  },
  {
    slug: 'mari-to-acquire-majority-stake-in-bucket-listers',
    title:
      'MARI to Acquire Majority Stake in Bucket Listers, Unlocking Social-Driven Demand for Live Experiences',
    metaTitle: 'MARI to Acquire Majority Stake in Bucket Listers | MARI Group',
    breadcrumb: 'MARI to Acquire Majority Stake in Bucket Listers',
    date: 'FEB 4, 2026',
    description:
      'New global events and experiences company launches to build a world-class portfolio across sports, entertainment, art, and lifestyle',
    bodyHtml: `
      <p>
        BEVERLY HILLS, Calif., Feb. 4, 2026 – MARI, the global live events and experiences company, today announced it has acquired a majority stake in Bucket Listers, a leading event discovery platform that helps audiences discover and access events and activities in their city, ranging from immersive experiences and pop-up restaurants to cultural festivals and seasonal events. 
      </p>

      <p>
        The acquisition reflects MARI’s focus on building a more connected audience journey – from discovery and choice through to participation and re-engagement. Originally built as a social-first discovery platform and later expanded into original experiences and media, Bucket Listers has built a highly engaged, experience-seeking audience, and a strong social and editorial presence. Alongside its discovery capability, Bucket Listers also develops and produces original live experiences in collaboration with IP partners, such as Mattel, Disney, and CBS/Paramount.  
      </p>

      <p>
        Within MARI’s portfolio, Bucket Listers will complement TodayTix Group, MARI’s global platform for discovering and attending live performances and cultural events. By adding social-first audience engagement and original experiences, Bucket Listers strengthens MARI’s understanding of consumer demand across broader demographics and will support growth across the portfolio into new categories of experiences. 
        “Bucket Listers gives us deeper insight into how audiences discover and decide what to do,” said Ariel Emanuel, Founder and Principal Investor of MARI. “As technology continues to reshape how time and attention are spent, Bucket Listers helps us engage audiences, understand demand more clearly, and build stronger relationships across the MARI portfolio.” 
      </p>

      <p>
        “Live experiences remain one of the few trillion-dollar categories without a destination that aggregates supply and makes discovery frictionless,” said Andy Lederman, Founder and CEO of Bucket Listers. “As we continue to establish Bucket Listers as that destination for both consumers and producers – offering the widest,  highest quality selection across markets and categories – we could not imagine  a better partner than MARI, with its expanding world-class portfolio of global experiences.  We are honored to join forces with Ari, Mark and team, along with  TodayTix, on a collective mission to modernize and reshape the future of live experiences.”
      </p>

      <p>
        Bucket Listers operates across multiple U.S. cities and has built a large, socially engaged community of 21 million around editorial recommendations for events, pop-ups and experiences. Bucket Listers will work closely with MARI’s portfolio companies, while continuing to operate as a distinct brand, led by its existing management team.
      </p>

      <p>
        Terms of the transaction were not disclosed. 
      </p>

      <h2>EDITORS’ NOTES</h2>

      <h3>About Bucket Listers</h3>
      <p>
        Founded in 2018 by Andy Lederman, Bucket Listers is the go-to guide and platform for discovering the best events and experiences across 20 cities in the U.S.. With over 21 million social followers and 2.5 billion annual impressions, Bucket Listers reaches audiences through social-first storytelling and highly curated city guides. The business operates across three distinct business lines: Bucket Listers App is the destination for locals to discover and book thousands of curated events across all categories, while enabling producers to scale through industry-leading booking, marketing, and creative agency services. To date, the platform has driven three million tickets sold. Bucket Listers Presents creates, produces, and scales original and IP-based experiences in partnership with major studios and IP holders, including the Malibu Barbie Café with Mattel, Family Guy Experience with Disney, and Survivor Café with CBS/Paramount. Bucket Listers Brand Division partners with the world’s leading brands to deliver social media campaigns, digital marketing, on-site activations, and bespoke creative agency services. At its core, Bucket Listers is a community built around exploring our cities together, with a mission of Inspiring Experiences.  
      </p>
      <h3>About MARI</h3>
      <p>
        MARI is a global events and experiences company with a portfolio of world-class live properties spanning sport, art, lifestyle, and entertainment. These include major international tennis tournaments, among them the Mutua Madrid Open and Miami Open presented by Itaú, Frieze, a leading voice in contemporary art, Hyde Park Winter Wonderland, TodayTix Group, a leading digital ticketing and technology company for theatre and live performance, and Barrett-Jackson, the foremost U.S. collector car auction company. MARI delivers live experiences that bring people together, inspire audiences, and shape culture worldwide.  
      </p>
    `,
  },
  {
    slug: 'mari-grows-global-portfolio',
    title:
      'MARI Grows Global Portfolio of Lifestyle, Cultural, and Athletic Events',
    metaTitle:
      'MARI Grows Global Portfolio of Lifestyle, Cultural & Athletic Events | MARI Group',
    breadcrumb: 'Mari Grows Global Portfolio',
    date: 'NOV 3, 2025',
    description:
      'From Hyde Park Winter Wonderland to Taste Festivals and the Melbourne Marathon, new additions broaden MARI’s reach worldwide',
    bodyHtml: `
      <p>BEVERLY HILLS, Calif., Nov. 3, 2025 – MARI, the global events and experiences company founded 
      by Ariel Emanuel, today announced the acquisition of IMG’s Arts & Entertainment and Action Sports 
      events portfolios, expanding its international footprint with popular festivals, touring exhibitions, family 
      programming, and athletic events that attract millions of participants and visitors each year around the 
      world. </p>

      <p>The acquisition brings signature events including Hyde Park Winter Wonderland, which welcomes 
      more than three million visitors each holiday season, and the global Taste Festivals culinary series, 
      headlined by the Taste of London. The sports portfolio includes category-leading properties such as 
      the US Open of Surfing in Southern California and the Nike Melbourne Marathon, expanding MARI’s 
      presence in mass-participation athletic events. These acquisitions increase the scale and reach of 
      MARI’s portfolio, reflecting the company’s goal to build a leading network of events and experiences 
      worldwide.</p>

      <p>Ariel Emanuel, Founder and Principal Investor, MARI, said: “From London’s iconic Hyde Park Winter 
      Wonderland to Taste Festivals worldwide, MARI’s growing presence across Europe, North America, 
      Asia, and Australia furthers our ambition to build a global portfolio of cultural, lifestyle, and sporting 
      events that connect millions of people through live experiences.”</p>

      <p>Together with recent additions — Frieze, Barrett-Jackson, TodayTix Group, and a tennis portfolio 
      featuring the Miami Open presented by Itaú, the Mutua Madrid Open, and other leading ATP and WTA 
      tournaments — these acquisitions signal MARI’s ambition to build a category-defining collection of 
      events that unite audiences through culture, content, and community.</p>

      <p>Akin Gump Strauss Hauer & Feld LLP acted as legal adviser and Goldman Sachs & Co. 
      and LionTree Advisors LLC acted as financial advisers to MARI in connection with the transaction.</p>

      <h2>EDITORS’ NOTES </h2>

      <h3>About MARI</h3>

      <p>MARI is a global events and experiences company with a portfolio of world-class live properties 
      spanning sport, art, lifestyle, and entertainment. These include major international tennis tournaments, 
      among them the Mutua Madrid Open and Miami Open presented by Itaú, Frieze, a leading voice in 
      contemporary art, Hyde Park Winter Wonderland, TodayTix Group, a leading digital ticketing and 
      technology company for theatre and live performance, and Barrett-Jackson, the foremost U.S. 
      collector car auction company. MARI delivers live experiences that bring people together, inspire 
      audiences, and shape culture worldwide.</p>
    `,
  },
  {
    slug: 'mari-expands-global-events-portfolio',
    title:
      'MARI Expands Global Events Portfolio with Acquisition of TodayTix Group, Leader in Digital Ticketing for Live Performance',
    metaTitle:
      'MARI Expands Global Events Portfolio with Acquisition of TodayTix Group | MARI Group',
    breadcrumb: 'Mari Acquires TodayTix Group',
    date: 'OCT 20, 2025',
    description:
      'BEVERLY HILLS, Calif., Oct. 20, 2025 – MARI, the new global events and experiences company founded by Ariel Emanuel, today announced its acquisition of TodayTix Group (TTG, or the Company)...',
    bodyHtml: `
      <p>BEVERLY HILLS, Calif., Oct. 20, 2025 – MARI, the new global events and experiences company 
    founded by Ariel Emanuel, today announced its acquisition of TodayTix Group (TTG, or the Company), 
    the leading mobile and digital ticketing company for live cultural experiences and the performing arts, 
    from Great Hill Partners, a private equity firm that invests in high-growth, disruptive companies. The 
    acquisition complements MARI’s portfolio – which already includes the Miami Open presented by Itaú 
    and Mutua Madrid Open, Frieze, and Barrett-Jackson – by introducing market-leading ticketing 
    technology and strengthening its connection to theatre and live performance.</p>

    <p>With more than 20 million members across the U.S., U.K., and Australia, TodayTix Group has become 
    synonymous with seamless access to live entertainment. Named App of the Day by Apple and 
    recognized by Fast Company as one of the World’s Most Innovative Companies, TTG has reimagined 
    how people discover and experience theatre and performance. Through its suite of brands, including 
    TodayTix, Secret Cinema, LondonTheatre, and Show-Score, the Company has established itself as both 
    a consumer destination and a trusted partner to more than 10,000 theatres, producers, and cultural 
    institutions worldwide.</p>

    <p>TodayTix Group will bring its award-winning technology, AI-driven personalization, and data science 
    capabilities to MARI’s growing collection of global events, alongside its extensive partner network. The 
    addition of TTG will enable MARI to redefine the event lifecycle – from discovery to purchase to post - event engagement – while giving partners and creators new tools to unlock insight and demand. Brian 
    Fenty, Co-Founder and CEO of TodayTix Group, will remain CEO of the Company with an expanded 
    remit across the portfolio, and will also join MARI’s executive leadership team. Co-Founder Merritt Baer 
    will continue as Artistic Director and Producer at Secret Cinema. </p>

    <p>MARI is led by Ariel Emanuel, Founder and Principal Investor, together with Mark Shapiro, Principal 
    Investor and Board Member. The Company’s executive leadership team includes Matt Cohn as 
    Managing Partner and Ben Enowitz as Chief Financial Officer, who oversee MARI’s portfolio of live 
    events and drive growth across sport, art, lifestyle, and entertainment.</p>

    <p>“This is the next step in building MARI as a global leader in live experiences,” said Ariel Emanuel. “With 
    TodayTix, we’re adding a technology engine and a direct line to audiences that makes our portfolio even 
    more powerful. Alongside sport, art, and lifestyle, theatre and immersive performance now sit at the core 
    of what we do – expanding our reach and deepening how we connect people with defining live 
    experiences.”</p>

    <p>“TodayTix was born to democratize access to culture,” said Brian Fenty. “Over the past decade, we’ve 
    built a platform that audiences lean on, theatres trust, and producers depend upon. We’ve always 
    believed the future of live entertainment would be shaped by elevated, singular experiences amplified 
    with technology that removes friction and elevates the hospitality experience throughout. MARI shares 
    that belief and the ambition to scale at pace. Together, we will elevate user experience, empower 
    creators, and redefine the event-level offering in ways the world hasn’t yet seen, with purpose-built AI for 
    the future of events. We are thrilled to join the MARI family and brand, and are equally appreciative to the 
    Great Hill Partners team, who have provided incredible support, resources, and value creation over the 
    course of their six-year investment that enabled the Company to achieve incredible growth and 
    momentum.” </p>

    <p>“We have enjoyed a fantastic partnership with TodayTix,” said Michael Kumin, Managing Director at 
    Great Hill Partners. “Since investing in 2019, the Company has shown impressive resiliency while 
    successfully executing numerous organic and inorganic growth initiatives. We would like to thank Brian, 
    Merritt, and the TodayTix team, and are confident that the Company will continue to prosper as part of 
    the MARI platform.”</p>

    <p>Akin Gump Strauss Hauer & Feld LLP served as legal counsel to MARI. Moelis & Company LLC and 
    LionTree Advisors LLC served as financial advisors and Paul Hastings LLP served as legal counsel to 
    TodayTix Group and Great Hill Partners.</p>


    <h2>EDITORS’ NOTES </h2>

    <h3>About MARI</h3>

    <p>MARI is a global events and experiences company with a portfolio of premium live properties across 
    sports, art, lifestyle, and entertainment. These include the Madrid and Miami Open tennis tournaments 
    and Frieze, a leading voice in contemporary art, as well as Barrett-Jackson, the premium U.S. collector 
    car auction company. MARI delivers unforgettable live experiences that connect people, inspire 
    audiences, and shape culture.</p>

    <h3>About TodayTix Group </h3>

    <p>TodayTix Group is the global e-commerce leader for cultural experiences. TodayTix Group designs 
    frictionless e-commerce experiences via innovative product design and industry-leading technology. 
    Through its powerful consumer matchmaking technology and expansive portfolio of brands, including 
    TodayTix, Secret Cinema, and Show-Score, TodayTix Group has an intimate understanding of its 
    millions of customers, allowing TodayTix Group to optimize partner relationships by providing 
    unparalleled access to engaged audiences, generating meaningful revenue, and transforming the way 
    tickets are sold. And with an ever-expanding global network of more than 10,000 theatres, producers, 
    and cultural institutions, frictionless technology, and vast data and insights, TodayTix Group is at the 
    forefront of the digital transformation of culture. To learn more, visit <a href="https://todaytixgroup.com" target="_blank">www.todaytixgroup.com</a> or
    <a href="https://www.marigrp.com" target="_blank">marigrp.com</a>.</p>

    <h3>About Great Hill Partners </h3>

    <p>Founded in 1998, Great Hill Partners is a private equity firm targeting investments of $100 million to $750 
    million in high-growth companies across the software, financial services, healthcare, consumer, and 
    business services sectors. With offices in Boston and London, Great Hill has raised funds with over $19 
    billion in commitments and invested in more than 100 companies since 1998, establishing an extensive 
    track record of building long-term partnerships with entrepreneurs and providing flexible resources to 
    help middle-market companies scale. Great Hill has been recognized for its industry leadership, ranking 
    in the top five of HEC Paris-Dow Jones' Mid-Market and Large Buyout Performance Ranking lists 
    consecutively for the four most recent years published (2021–2024). For more information, including a 
    list of all Great Hill investments, please visit <a href="https://www.greathillpartners.com" target="_blank">www.greathillpartners.com</a>. 
    Disclaimer: Great Hill Partners did not provide any compensation to HEC Paris-Dow Jones to be 
    considered for any of these rankings. </p>
    `,
  },
  {
    slug: 'mari-completes-acquisitions-madrid-miami',
    title:
      'MARI Completes Acquisitions of the Madrid and Miami Open Tennis Tournaments and International Art Organization Frieze, and Barrett-Jackson, the Premium Collector Car Auction Company',
    metaTitle:
      'MARI Completes Acquisitions of Madrid & Miami Open, Frieze & Barrett-Jackson | MARI Group',
    breadcrumb: 'Mari Acquires Madrid Miami Open Frieze Barrett Jackson',
    date: 'OCT 8, 2025',
    description:
      'New global events and experiences company launches to build a world-class portfolio across sports, entertainment, art, and lifestyle',
    bodyHtml: `
      <h2>
        New global events and experiences company launches to build a
        world-class portfolio across sports, entertainment, art, and lifestyle
      </h2>

      <p>
        BEVERLY HILLS, Calif., Oct. 8, 2025 – MARI, a new global events and
        experiences company founded by Ariel Emanuel, launched today following
        its acquisitions of IMG’s portfolio of international tennis events and
        Frieze—the globally influential contemporary art organization—and a
        majority ownership interest in Barrett-Jackson, the premium collector
        car auction and automotive lifestyle brand, alongside Barrett-Jackson
        founder and CEO Craig Jackson, who will remain in his role.
      </p>

      <p>
        The tennis portfolio includes two premier ATP Masters 1000 and WTA 1000
        tournaments—the Miami Open presented by Itaú and Mutua Madrid
        Open—alongside leading WTA events such as the Mubadala Abu Dhabi Open,
        Mubadala Citi DC Open, and SP Open. It also features high-profile
        exhibitions such as Giorgio Armani Tennis Classic and MGM Macau Tennis
        Masters, as well as the management of major ATP tournaments including
        the Chengdu Open, Hong Kong Open, Japan Open, and Rio Open.
      </p>

      <p>
        Emanuel, together with Mark Shapiro who is a Principal Investor and will
        serve as a Board Member, will guide MARI’s strategy and growth as the
        company builds a portfolio of iconic events and brands. Together, they
        bring decades of experience shaping world-class businesses across
        sports, entertainment, and culture.
      </p>

      <p>
        MARI’s executive team includes Matt Cohn as Managing Partner and Ben
        Enowitz as Chief Financial Officer. This group will oversee MARI’s
        portfolio of live events and drive growth across sports, art, lifestyle,
        and entertainment. All events will continue under their existing
        leadership, now within MARI, ensuring continuity and momentum.
      </p>

      <p>
        MARI is backed by a global group of leading investors, including  funds
        managed by Apollo, RedBird Capital Partners, Qatar Investment
        Authority, HSG, IMI media group, Ares Management funds, Dr. Patrick
        Soon-Shiong, a16z Growth, Nancy Zhang, FORTA Advisors, Main Street
        Advisors, Causeway Media Partners, Gannet Capital, Eric Schmidt, FMZ
        Ventures, Sideline Group, Curated Wealth Partners, Gaurav Kapadia, Bulat
        Utemuratov, and Sanjay Govil, as well as superstars from the sports
        world including Luka Dončić, Anthony Edwards and Sabrina Ionescu.
      </p>

      <p>
        As part of the Miami Open acquisition, MARI is bringing on the ownership
        group behind the Miami Dolphins, Hard Rock Stadium, and the Formula 1
        Crypto.com Miami Grand Prix, as principal investors. The group includes
        majority owner Stephen Ross, along with Joe Tsai, Oliver Weisberg, and
        funds managed by Ares Management. Since 2019, the Miami Open has been
        hosted at Hard Rock Stadium, a world-class sports and entertainment
        venue.
      </p>

      <p>
        “Live events and experiences have never been more powerful,” said Ariel
        Emanuel, Founder and Principal Investor of MARI. “As people increasingly
        value experiences over things—and as hybrid work and AI give us more
        time to enjoy them—sports, art, lifestyle, and entertainment are
        becoming even more essential. At MARI, we’re building on the global
        impact of Frieze and the success of the Madrid and Miami Opens to create
        new ways for audiences to come together and share their passions.”
      </p>

      <p>
        “We are excited to be a key partner to Ariel Emanuel, Mark Shapiro, and
        their team as they build out a portfolio of experiential assets in the
        sports and live events industries—two key areas where our firm sees
        strong, continued growth. Apollo Sports Capital will work closely with
        the MARI team to help unlock value across the existing asset base, as
        well as explore additional opportunities in live events and
        experiences,” added Apollo Partner Rob Givone.
      </p>

      <p>
        “RedBird has enjoyed a multi-decade partnership with Ari and Mark, and
        we are excited to join them again in creating MARI,” said Gerry
        Cardinale, Founder and Managing Partner of RedBird Capital. “Anchored by
        the iconic Miami and Madrid Tennis Opens and Frieze, MARI is well
        positioned from inception to capitalize on the secular growth and
        convergence of premium intellectual property across Sports and Live
        Event Entertainment—areas where RedBird brings domain leadership and
        business building expertise.”
      </p>

      <p>
        Frieze, Barrett-Jackson, and the tennis properties will serve as
        flagship assets of MARI’s global events and experiences portfolio. These
        acquisitions reflect MARI’s long-term vision to build a dynamic
        collection of category-defining events that bring people together
        through culture, content, and community.
      </p>

      <p>
        Akin Gump Strauss Hauer & Feld LLP acted as legal adviser and Goldman
        Sachs & Co. and LionTree Advisors LLC acted as financial advisors to
        MARI in connection with the transaction.
      </p>

      <h2>EDITORS’ NOTES</h2>

      <h3>About MARI</h3>
      <p>
        MARI is a global events and experiences company with a portfolio of
        premium live properties across sports, art, and entertainment. These
        include the Madrid and Miami Open tennis tournaments and Frieze, a
        leading voice in contemporary art, as well as Barrett-Jackson, the
        Premium U.S. Collector Car Auction Company. MARI delivers unforgettable
        live experiences that connect people, inspire audiences, and shape
        culture.
      </p>
      <h3>About the Miami Open</h3>
      <p>
        The 2026 Miami Open will be played March 15 – March 29 at Hard Rock
        Stadium. The 15-day combined event is one of nine ATP Masters 1000
        Series events on the ATP calendar, a WTA 1000 event on the WTA calendar,
        and features the top men’s and women’s tennis players in the world. The
        tournament is widely regarded as the most glamorous on the ATP and WTA
        calendars because of Miami’s unique personality, thriving nightlife,
        five-star hotels and restaurants, beautiful weather and beaches, and
        celebrity appeal, as well as its close proximity to both Fort Lauderdale
        and West Palm Beach. For more information, visit <a href="https://www.miamiopen.com" target="_blank">MiamiOpen.com</a>.
      </p>
      <h3>About the Madrid Open</h3>
      <p>
        The Madrid Open is an ATP Masters 1000 and WTA 1000 tournament that will
        hold its 24th edition from April 20 – May 3, 2026, in Madrid, Spain.
        What began as an indoor Masters 1000 event in 2002 has grown in recent
        years to become one of the biggest combined (ATP and WTA) tournaments in
        the world of tennis. After moving to the Caja Mágica in 2009, adding the
        women’s competition and moving to clay courts in spring, the Mutua
        Madrid Open has become a must-see event for tennis fans around the
        world. Currently recognised as one of Spain’s biggest sports events, the
        tournament welcomed a record 380,073 fans in 2024 and is broadcast in
        more than 180 countries every year. For more information, visit
        <a href="https://www.mutuaMadridOpen.com" target="_blank">MutuaMadridOpen.com</a>.
      </p>
      <h3>About MARI Tennis Portfolio</h3>
      <p>
        MARI’s global tennis portfolio includes some of the sport’s most
        prestigious tournaments and exhibitions, spanning ATP Masters 1000, WTA
        1000, ATP 500, and WTA events. Highlights include the Madrid Open and
        Miami Open—two of the nine ATP Masters 1000 and WTA 1000 tournaments—as
        well as the Mubadala Abu Dhabi Open, Mubadala Citi DC Open, and SP Open.
        The portfolio also features elite ATP tournaments such as the Japan
        Open, Rio Open, Chengdu Open, and Hong Kong Open, along with celebrated
        exhibitions including the Giorgio Armani Tennis Classic and MGM Macau
        Tennis Masters. Together, these events attract the world’s top players
        and audiences.
      </p>
      <h3>About Frieze</h3>
      <p>
        Frieze is a leading global contemporary art organisation, recognized for
        its art fairs, publications and digital presence. Founded in 1991 with
        the launch of frieze magazine, the brand has grown to encompass seven of
        the most significant art fairs worldwide in cities including Chicago,
        London, Los Angeles, New York and Seoul. These events attract leading
        artists, galleries and collectors, fostering innovative dialogues and
        practices within the art community. Frieze magazine continues to set the
        benchmark for insightful art criticism and commentary, while <a href="https://frieze.com" target="_blank">frieze.com</a>
        serves as a vital online resource. Committed to expanding the reach and
        understanding of contemporary art, Frieze also hosts year-round curated
        programs and associated initiatives, such as No.9 Cork Street, Frieze
        House Seoul and Frieze Connects, that enrich the cultural landscape.
      </p>
      <p>
        With a dedicated team passionate about the arts, Frieze remains at the
        forefront of artistic exploration and cultural discourse, connecting
        diverse audiences with groundbreaking artists and their work. For more
        information, visit <a href="https://frieze.com" target="_blank">frieze.com</a>.
      </p>
      <h3>About The Barrett-Jackson Auction Company</h3>
      <p>
        Established in 1971 and headquartered in Scottsdale, Arizona,
        Barrett-Jackson, The World’s Greatest Collector Car Auctions, is the
        leader in collector car auctions and automotive lifestyle events, which
        include authentic automobilia auctions and the sale of private
        collections. Welcoming hundreds of thousands of attendees per year,
        Barrett-Jackson produces several live collector car auctions where
        thousands of the most sought-after, unique and valuable automobiles
        cross the block in front of a global audience. With broadcast partner
        A+E Networks, Barrett-Jackson features live television coverage of their
        events on FYI and The HISTORY Channel, as well as all the cars, all the
        time via their produced livestream on <a href="https://barrett-jackson.com" target="_blank">Barrett-Jackson.com</a>.
        Barrett-Jackson also endorses a one-of-a-kind collector car insurance
        for collector vehicles and other valued belongings.
      </p>
    `,
  },
];

export function getArticleBySlug(slug: string): ArticleItem | undefined {
  return ARTICLES.find((a) => a.slug === slug);
}
